import { render, staticRenderFns } from "./ProductionDetail.vue?vue&type=template&id=33b6816c&scoped=true"
import script from "./ProductionDetail.vue?vue&type=script&lang=js"
export * from "./ProductionDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductionDetail.vue?vue&type=style&index=0&id=33b6816c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6816c",
  null
  
)

export default component.exports